//
// GENERATED by KVision
//
package pl.finn.forms.tw17

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.Zalacznik
import pl.finn.forms.tw17.Tw17Form
import pl.finn.forms.tw17.Tw17FormData

actual class Tw17Service(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : ITw17Service, KVRemoteAgent<Tw17Service>(Tw17ServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(ITw17Service::nowy, token)
    override suspend fun edycja(token: String) = call(ITw17Service::edycja, token)
    override suspend fun sprawdz(tw1Form: Tw17Form, zalaczniki: List<Zalacznik>, token: String) = call(ITw17Service::sprawdz, tw1Form, zalaczniki, token)
    override suspend fun zapisz(tw1Form: Tw17Form, zalaczniki: List<Zalacznik>, validateResult: String?, token: String) = call(ITw17Service::zapisz, tw1Form, zalaczniki, validateResult, token)
    override suspend fun podglad(tw1Form: Tw17Form, zalaczniki: List<Zalacznik>, token: String) = call(ITw17Service::podglad, tw1Form, zalaczniki, token)
}
